import { render, staticRenderFns } from "./ViewTreePanel.vue?vue&type=template&id=183cdef4&scoped=true"
import script from "./ViewTreePanel.vue?vue&type=script&lang=js"
export * from "./ViewTreePanel.vue?vue&type=script&lang=js"
import style0 from "./ViewTreePanel.vue?vue&type=style&index=0&id=183cdef4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183cdef4",
  null
  
)

export default component.exports